/** @file Constraints panel body: IK constraints in update order, the selected one's fields, a new-IK row. */
import { useState } from 'react';
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import { listHandlers } from '../rigKit/listHandlers';
import { NamedList } from '../rigKit/NamedList';
import type { RigView } from '../rigKit/rigView';
import { IkCreate } from './IkCreate';
import { IkFields } from './IkFields';

/** Rows sorted by `order`, then name; the note spells the chain and the target by bone name. */
export function ConstraintsView(view: RigView) {
  const { doc, t, run } = view;
  const [picked, setPicked] = useState<string | null>(null);
  const bone = (id: string): string => doc.bones[id]?.name ?? id;
  const rows = entriesByName(doc.constraints).sort(([, a], [, b]) => a.order - b.order)
    .map(([id, c]) => ({ id, name: c.name, note: t('panels.constraints.chainNote', { bones: c.bones.map(bone).join(' > '), target: bone(c.target) }) }));
  const ik = picked === null ? undefined : doc.constraints[picked];
  return (
    <div className="rig-body">
      <NamedList t={t} label={t('panels.constraints.title')} rows={rows} selected={ik === undefined ? null : picked} onSelect={setPicked} {...listHandlers('ik', run)} />
      {picked !== null && ik !== undefined && <IkFields view={view} id={picked} ik={ik} />}
      <IkCreate doc={doc} t={t} run={run} />
    </div>
  );
}
